import { VideoCameraFront } from "@mui/icons-material";
import { IFeatures } from "@/utils/interfaces";
import { useSessionContext } from "@/contexts/SessionContext";
import { useViewContext } from "@/contexts/ViewContext";
import { useTeleconsultoriaContractContext } from "@/contexts/TeleconsultoriaContractContext";
import { TeleconsultoriaPage } from "./TeleconsultoriaPage";

export function useTeleconsultoria() {
  const { access } = useSessionContext();
  const { availableRoles } = useViewContext();
  const { contractTeleconsultoria } = useTeleconsultoriaContractContext();
  const isPractitioner = availableRoles?.includes("practitioner");
  const canClinic =
    availableRoles?.includes("manager") ||
    availableRoles?.includes("owner") ||
    availableRoles?.includes("associated");

  const configs: IFeatures = {
    active:
      access.type === "professional" &&
      Boolean(contractTeleconsultoria) &&
      (Boolean(isPractitioner) || Boolean(canClinic)),
    path: "/teleconsultoria",
    icon: VideoCameraFront,
    text: "Teleconsultoria",
    sideMenu: true,
    sideMenuIndex: 0,
    component: () => <TeleconsultoriaPage />,
  };

  return configs;
}
